// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"LinksConfig_linkItem__8rxta","linkLabel":"LinksConfig_linkLabel__TEDkw","loaderAnimation":"LinksConfig_loaderAnimation__dtnm_"};